import src from "IMAGE";
export default { src, width: 68, height: 89, blurWidth: 0, blurHeight: 0};
